import { render, staticRenderFns } from "./highlighted-articles.vue?vue&type=template&id=1af4332e"
import script from "./highlighted-articles.vue?vue&type=script&lang=js"
export * from "./highlighted-articles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports